<div class="flex flex-col h-full">
	<ng-container *ngIf="vm$ | async as vm">
		<ui-content-header title="Document Templates" type="page">
			<ui-button
				title-action
				label="Create Template"
				icon="plus"
				(click)="createTemplate()"
			></ui-button>
		</ui-content-header>
		<div class="flex gap-x-4 overflow-auto">
			<div class="flex flex-col gap-4 min-w-64 pr-4 border-r border-gray-200">
				<div class="flex justify-between items-center gap-4">
					<div class="flex items-center gap-2">
						<i-tabler name="filter" class="w-4 h-4 text-gray-500"></i-tabler>
						<h5 class="h5">Filters</h5>
						<div
							*ngIf="activeFilterCount > 0"
							class="text-xs text-white h-6 w-6 rounded-full flex items-center justify-center bg-blue-500"
						>
							{{ activeFilterCount }}
						</div>
					</div>
					<ui-button
						preset="EXTRA_LOW_EMPHASIS"
						size="sm"
						label="Clear"
						icon="refresh"
						(click)="clearFilters()"
					></ui-button>
				</div>
				<div class="flex flex-col border-t border-gray-200 pt-4">
					<div class="flex mb-2">
						<p class="p-xs font-medium text-gray-500 tracking-widest uppercase">
							Matter File Types
						</p>
					</div>
					<ng-container *ngFor="let type of matterFileTypes | keyvalue">
						<div
							(click)="toggleFileType(type.value)"
							class="flex justify-between items-center p-2 mb-1 rounded-md w-full hover:bg-gray-100 cursor-pointer duration-300"
							[class.bg-gray-100]="isSelected(type.value)"
						>
							<div class="flex items-center gap-2">
								<div
									class="w-6 h-6 flex items-center justify-center rounded-md border text-xs"
									[ngClass]="{
										'bg-yellow-50 border-yellow-200 text-yellow-700':
											type.value === matterFileTypes.SALE,
										'bg-blue-50 border-blue-200 text-blue-700':
											type.value === matterFileTypes.PURCHASE,
										'bg-purple-50 border-purple-200 text-purple-700':
											type.value === matterFileTypes.REFINANCE,
									}"
								>
									{{ type.value.charAt(0) | uppercase }}
								</div>
								<p class="p-sm text-gray-500 capitalize">
									{{ type.value }}
								</p>
							</div>
							<i-tabler
								*ngIf="isSelected(type.value)"
								name="x"
								class="w-4 h-4 text-gray-500"
							></i-tabler>
						</div>
					</ng-container>
					<div
						(click)="toggleFileType('unassigned')"
						class="flex justify-between items-center p-2 mb-1 rounded-md w-full hover:bg-gray-100 cursor-pointer duration-300"
						[class.bg-gray-100]="isSelected('unassigned')"
					>
						<div class="flex items-center gap-2">
							<div
								class="w-6 h-6 flex items-center justify-center rounded-md border text-xs bg-gray-50 border-gray-200 text-gray-700"
							>
								U
							</div>
							<p class="p-sm text-gray-500 capitalize">Unassigned</p>
						</div>
						<i-tabler
							*ngIf="isSelected('unassigned')"
							name="x"
							class="w-4 h-4 text-gray-500"
						></i-tabler>
					</div>
					<div class="flex my-2">
						<p class="p-xs font-medium text-gray-500 tracking-widest uppercase">
							Status
						</p>
					</div>
					<div
						(click)="toggleStatus('lastUpdated')"
						class="flex justify-between items-center p-2 mb-1 rounded-md w-full hover:bg-gray-100 cursor-pointer duration-300"
						[class.bg-gray-100]="isSelectedStatus('lastUpdated')"
					>
						<p class="p-sm text-gray-500 capitalize">Last updated</p>
						<i-tabler
							*ngIf="isSelectedStatus('lastUpdated')"
							name="x"
							class="w-4 h-4 text-gray-500"
						></i-tabler>
					</div>
				</div>
			</div>
			<div class="flex-1 flex flex-col overflow-auto">
				<div class="mb-4">
					<div class="relative">
						<i-tabler
							name="search"
							class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
						></i-tabler>
						<input
							#searchInput
							placeholder="Search templates by name or type"
							class="p-sm pl-8 pr-12 py-2 rounded-md border border-gray-200 w-full focus:outline-green placeholder:text-gray-500"
							[formControl]="searchFormControl"
						/>
						<ui-button
							*ngIf="searchFormControl.value"
							(click)="clearSearch(searchInput)"
							preset="ICON_DEFAULT"
							size="xs"
							icon="x"
							class="absolute right-2 top-1/2 -translate-y-1/2"
						>
						</ui-button>
					</div>
				</div>
				<div class="p-sm text-gray-500 mb-2">
					{{ vm.filteredDocuments.length }} Templates
				</div>
				<div class="flex flex-col gap-2 flex-1 overflow-auto">
					<ui-template-list-item
						*ngFor="let doc of vm.filteredDocuments; trackBy: trackByDocumentId"
						[document]="doc"
						(documentClick)="openDocumentPreviewModal($event)"
						(documentDoubleClick)="openDocumentPreviewModal($event)"
						(openDocumentInWord)="openDocumentPreviewModal($event)"
						[dropdownItems]="getDropdownItems(doc.id)"
						[isOpening]="vm.documentsOpening.includes(doc.id)"
					>
						<div
							below-title
							*ngFor="let type of doc.matterType"
							class="px-2 py-1 text-xs text-gray-600 rounded-md border border-transparent flex"
							[ngClass]="{
								'bg-yellow-50 !border-yellow-200': type === 'sale',
								'bg-blue-50 !border-blue-200': type === 'purchase',
								'bg-purple-50 !border-purple-200': type === 'refinance',
								'order-1': type === vm.selectedMatterFileType,
								'order-2': type !== vm.selectedMatterFileType,
							}"
						>
							<p
								class="p-xs capitalize"
								[ngClass]="{
									'!text-yellow-700': type === 'sale',
									'!text-blue-700': type === 'purchase',
									'!text-purple-700': type === 'refinance',
								}"
							>
								{{ type }}
							</p>
						</div>
					</ui-template-list-item>
				</div>
			</div>
		</div>
	</ng-container>
</div>
